var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10666_8618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 7.4375C6.05542 7.4375 3.1875 10.3054 3.1875 13.8125C3.1875 15.9209 4.2251 17.7969 5.81055 18.959C3.00903 20.3494 1.0625 23.2297 1.0625 26.5625H3.1875C3.1875 23.0305 6.03052 20.1875 9.5625 20.1875C13.0945 20.1875 15.9375 23.0305 15.9375 26.5625H18.0625C18.0625 23.0305 20.9055 20.1875 24.4375 20.1875C27.9695 20.1875 30.8125 23.0305 30.8125 26.5625H32.9375C32.9375 23.2422 31.0117 20.3577 28.2227 18.959C29.061 18.4568 29.8455 17.8799 30.5469 17.2988C32.2319 15.9084 33.4355 14.5098 33.4355 14.5098L34.0664 13.8125L33.4688 13.1152C33.4688 13.1152 32.2527 11.7166 30.5801 10.3262C28.9075 8.93579 26.7783 7.4375 24.4375 7.4375C20.9304 7.4375 18.0625 10.3054 18.0625 13.8125C18.0625 15.9209 19.1001 17.7969 20.6855 18.959C19.1375 19.7268 17.8384 20.9387 17 22.4453C16.1616 20.9387 14.8625 19.7268 13.3145 18.959C14.8999 17.7969 15.9375 15.9209 15.9375 13.8125C15.9375 10.3054 13.0696 7.4375 9.5625 7.4375ZM9.5625 9.5625C11.9241 9.5625 13.8125 11.4509 13.8125 13.8125C13.8125 16.1741 11.9241 18.0625 9.5625 18.0625C7.20093 18.0625 5.3125 16.1741 5.3125 13.8125C5.3125 11.4509 7.20093 9.5625 9.5625 9.5625ZM24.4375 9.5625C25.7449 9.5625 27.6997 10.7205 29.2188 11.9863C30.3186 12.8994 30.7087 13.3767 31.1113 13.8125C30.7004 14.2483 30.2979 14.7214 29.1855 15.6387C27.6458 16.9045 25.6702 18.0625 24.4375 18.0625C22.0801 18.0625 20.1875 16.1699 20.1875 13.8125C20.1875 11.4551 22.0801 9.5625 24.4375 9.5625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10666_8618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorsicon);
export default __webpack_public_path__ + "static/media/tutorsicon.bdbb1d92e25836c5fabb48ed348cbbc2.svg";
export { ForwardRef as ReactComponent };